import React, { Fragment, useState } from "react";
import styled from "styled-components";

import {
  MARGING_LARGE_PX,
  MARGING_SMALL_PX,
  PADDING_XX_LARGE_PX,
  pixelize,
  UNIT,
  MARGING_X_LARGE_PX,
  MARGING_XX_LARGE_PX,
  PADDING_LARGE_PX
} from "constants/size";
import { Input } from "App/Atomics/Input";
import { Divider } from "App/Atomics/Divider";
import { ArtistTextAutoComplete } from "App/Molecules/AutoCompletes/Artist";
import { RoleTextAutoComplete, CharacterTextAutoComplete } from "App/Molecules/AutoCompletes/Role";
import { Info } from "App/Atomics/AutoComplete/TextAutoComplete";

type Artist = Readonly<{
  artist_id: string;
  artist_name: string;
  role_id: string;
  role_name: string;
  character_id?: string;
  character_name?: string;
  order?: number;
}>;

type Props = Readonly<{
  artistList: Artist[];
  onClick: (artistList: Artist[] | undefined) => void;
}>;

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  overflow: overlay;

  width: ${pixelize(UNIT * 60)};
  height: ${pixelize(UNIT * 30)};
  padding: ${PADDING_XX_LARGE_PX};

  h3 {
    margin-top: ${MARGING_SMALL_PX};
    margin-bottom: ${MARGING_X_LARGE_PX};
  }

  .suggestSpan {
    display: flex;
    flex-direction: row;
    margin-bottom: ${MARGING_XX_LARGE_PX};

    & > .autocomplete {
      width: 100%;
      margin-right: ${MARGING_LARGE_PX};
    }

    button {
      height: fit-content;
    }
  }
`;

const FilterGroup = styled.section`
  margin-bottom: ${MARGING_LARGE_PX};

  hr {
    margin-bottom: ${MARGING_X_LARGE_PX};
  }
`;

const ButtonGroup = styled(Input.Group)`
  display: flex;
  margin-top: auto;
  margin-left: auto;

  & > button {
    width: ${pixelize(UNIT * 5)};
  }
`;

const NameList = styled(Input.Group)`
  text-align: left;
  grid-template-columns: 30% 30% 30% 10%;

  & > span {
    padding: 0px ${PADDING_LARGE_PX};
  }

  & > button {
    margin-left: auto;
    border-radius: 50%;
    transform: scale(0.75);
  }
`;

export const ArtistMultiModal = ({ artistList: initialArtist, onClick }: Props) => {
  const [artistList, setArtistList] = useState(initialArtist.length ? initialArtist : ([] as Artist[]));
  const [artist, setArtist] = useState({} as Info);
  const [role, setRole] = useState({} as Info);
  const [character, setCharacter] = useState({} as Info);

  const toSave = () => onClick(artistList);
  const toCancel = () => onClick(undefined);

  const addArtist = (artist: any, role: any, character: any, order: number) => {
    if (!artistList.some(value => value.artist_id === artist.id && value.role_id === role.id)) {
      setArtistList([
        ...artistList,
        {
          artist_id: artist.id,
          artist_name: artist.name,
          role_id: role.id,
          role_name: role.name,
          character_id: character.id,
          character_name: character.name,
          order
        }
      ]);
    }
  };

  const removeArtist = (index: number) => setArtistList([...artistList.filter((value, idx) => index !== idx)]);

  return (
    <Layout>
      <h3>아티스트 / 역할 / 캐릭터 검색</h3>
      <FilterGroup>
        <span className="suggestSpan">
          <ArtistTextAutoComplete
            className="autocomplete"
            autoFocus
            onBlur={info => {
              if (info) {
                setArtist(info);
              } else {
                // TODO: 이미 입력을 해놓은 상태에서 지운 경우?
              }
            }}
          />
          <RoleTextAutoComplete
            className="autocomplete"
            onBlur={info => {
              if (info) {
                setRole(info);
              } else {
                // TODO: 이미 입력을 해놓은 상태에서 지운 경우?
              }
            }}
          />
          <CharacterTextAutoComplete
            className="autocomplete"
            onBlur={info => {
              if (info) {
                setCharacter(info);
              } else {
                // TODO: 이미 입력을 해놓은 상태에서 지운 경우?
              }
            }}
          />
          <Input.Button
            color="default"
            onClick={() => {
              if (artist && role) {
                const lastOrder = artistList[artistList.length - 1].order;
                addArtist(artist, role, character, lastOrder!);
              }
            }}
          >
            추가
          </Input.Button>
        </span>
        <Divider />
        {artistList.map((value, index) => {
          return (
            <Fragment key={index}>
              <NameList isAlign="baseline">
                <span>{value.artist_name}</span>
                <span>{value.role_name}</span>
                <span>{value.character_name}</span>
                <Input.Button color="danger" onClick={() => removeArtist(index)}>
                  -
                </Input.Button>
              </NameList>
            </Fragment>
          );
        })}
        <Divider />
      </FilterGroup>
      <ButtonGroup>
        <Input.Button onClick={toSave}>입력</Input.Button>
        <Input.Button onClick={toCancel}>취소</Input.Button>
      </ButtonGroup>
    </Layout>
  );
};
